/**
 * Chart Utility Functions
 * Shared utilities for formatting chart labels and data
 */

/**
 * Truncate long labels to prevent wrapping in charts
 * @param {string} label - The label to truncate
 * @param {number} maxLength - Maximum length before truncation (default: 20)
 * @returns {string} Truncated label with ellipsis if needed
 */
export const truncateLabel = (label, maxLength = 20) => {
  if (!label) return label || '';
  const str = String(label);
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength - 3) + '...';
};

/**
 * Format large numbers for display in charts
 * @param {number} value - The number to format
 * @returns {string} Formatted number (e.g., "1.5K", "2.3M")
 */
export const formatNumber = (value) => {
  if (value === null || value === undefined) return '0';
  if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return value.toLocaleString();
};

/**
 * Get optimal label length based on screen size and chart type
 * @param {boolean} isMobile - Whether current screen is mobile
 * @param {boolean} isTablet - Whether current screen is tablet
 * @param {number} dataLength - Number of data points
 * @param {boolean} isRotated - Whether labels are rotated
 * @returns {number} Optimal maximum label length
 */
export const getOptimalLabelLength = (isMobile, isTablet, dataLength = 0, isRotated = false) => {
  // If rotated, labels can be longer
  if (isRotated) {
    if (isMobile) return dataLength > 10 ? 18 : 22;
    if (isTablet) return dataLength > 10 ? 22 : 25;
    return dataLength > 10 ? 25 : 30;
  }
  
  // For horizontal labels, keep them shorter
  if (isMobile) return dataLength > 10 ? 12 : 15;
  if (isTablet) return dataLength > 10 ? 15 : 18;
  return dataLength > 10 ? 18 : 22;
};

